<div>
  <widget-area name="Dashboard" id="main-dashboard"></widget-area>
</div>
